module.exports = __webpack_public_path__ + "img/testi-tamamladiniz.75fd425e.svg";